/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardDinghyBookingDeleteController', BoardDinghyBookingDeleteController);

    BoardDinghyBookingDeleteController.$inject = ['$uibModalInstance', 'entity', 'BoardDinghyBooking'];

    function BoardDinghyBookingDeleteController($uibModalInstance, entity, BoardDinghyBooking) {
        var vm = this;

        vm.booking = entity;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BoardDinghyBooking.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
